import firebase from 'firebase/app'
import 'firebase/database'
import 'firebase/functions'

export default {
    db: function () {
        return firebase.database()
    },
    functions: function () {
        return firebase.functions()
    }
}
